import React from 'react';
import { Redirect } from 'react-router-dom';
import { urls } from '../utils';

export const NotFound: React.FC = () => <Redirect to={urls.profile} />;
